<script>
import RawData from "@/components/widgets/raw-data.vue";
import ApiSectionGroupForm from "@/components/widgets/apisectiongroupform.vue";
import ApiSectionForm from "@/components/widgets/apisectionform.vue";
import GroupItemForm from "@/components/widgets/apigroupitemform.vue";
export default {
    components: {
        RawData,
        ApiSectionGroupForm,
        ApiSectionForm,
        GroupItemForm
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    methods: {
        hasOptions(group) {
            if(!group.inputType) return false;
            let firstInputType = group.inputType.toLowerCase().split('|')[0].trim();
            return ['dropdown', 'radio', 'checkbox', 'checklist'].includes(firstInputType);
        },
        async viewGroups() {
            this.data.viewGroups = !this.data.viewGroups;
            if (this.data.viewGroups && !this.data.groups.length) {
                this.data.groupLoading = true;
                await this.getGroups();
                this.data.groupLoading = false;
            }
        },
        async getGroups() {
            try {
                const { data: response } = await this.$store.dispatch("apisection/GetGroupBySection", this.data.id);
                if(response.error){
                    return this.showToast(response.errorMessage, 'error');
                }
                response.map(item => {
                    item.edit = false;
                    item.addItem = false;
                    item.apiSectionGroupItems.map(groupItem => {
                        groupItem.edit = false;
                        return groupItem;
                    }); 
                });
                this.data.groups = response.sort((a, b) => a.sort - b.sort);
            } catch (error) {
                this.showToast('Something went wrong', 'error');
            }
        },
        async saveGroup(parent, modalData){
            try {
                modalData.apiSectionId = parent.id;
                if(modalData.id == 0){
                    let sort = parent.groups.sort((a, b) => a.sort - b.sort);
                    modalData.sort = sort.length > 0 ? parseInt(sort[sort.length - 1].sort) + 1 : 1;
                    const { data: response } = await this.$store.dispatch("apisection/CreateSectionGroup", modalData);
                    if(response.error){
                        return this.showToast(response.errorMessage, 'error');
                    }
                    response.edit = false;
                    response.addItem = false;
                    response.apiSectionGroupItems = [];
                    parent.groups.push(response);
                    parent.addGroup = false;
                    this.showToast('API Section Group created successfully', 'success');
                }else{
                    const { data: response } = await this.$store.dispatch("apisection/UpdateSectionGroup", modalData);
                    if(response.error){
                        return this.showToast(response.errorMessage, 'error');
                    }
                    const groupIndex = this.data.groups.findIndex(group => group.id === modalData.id);
                    modalData.edit = false;
                    modalData.addItem = false;
                    if (groupIndex !== -1) {
                        parent.groups.splice(groupIndex, 1, modalData);
                    }
                    this.showToast('API Section Group updated successfully', 'success');
                }
            } catch (error) {
                this.showToast('Something went wrong', 'error');
            } finally {
                parent.addGroup = false;
            }
        },
        deleteGroup(parent, group) {
            this.$swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const { data: response } = await this.$store.dispatch("apisection/RemoveSectionGroup", group.id);
                        if(response.error){
                            return this.showToast(response.errorMessage, 'error');
                        }
                        const groupIndex = parent.groups.findIndex(g => g.id === group.id);
                        if (groupIndex !== -1) {
                            parent.groups.splice(groupIndex, 1);
                        }
                        this.showToast('API Section Group deleted successfully', 'success');
                    } catch (error) {
                        this.showToast('Something went wrong', 'error');
                    }
                }
            });
        },
        async saveItem(parent, modalData){
            try {
                modalData.apiSectionGroupId = parent.id;
                if(modalData.id == 0){
                    let sort = parent.apiSectionGroupItems.sort((a, b) => a.sort - b.sort);
                    modalData.sort = sort.length > 0 ? parseInt(sort[sort.length - 1].sort) + 1 : 1;
                    const { data: response } = await this.$store.dispatch("apisection/CreateGroupItem", modalData);
                    if(response.error){
                        return this.showToast(response.errorMessage, 'error');
                    }
                    response.edit = false;
                    parent.apiSectionGroupItems.push(response);
                    this.showToast('Group Item created successfully', 'success');
                }else{
                    const { data: response } = await this.$store.dispatch("apisection/UpdateGroupItem", modalData);
                    if(response.error){
                        return this.showToast(response.errorMessage, 'error');
                    }
                    const itemIndex = parent.apiSectionGroupItems.findIndex(item => item.id === modalData.id);
                    if (itemIndex !== -1) {
                        modalData.edit = false;
                        parent.apiSectionGroupItems.splice(itemIndex, 1, modalData);
                    }
                    this.showToast('Group Item updated successfully', 'success');
                }
            } catch (error) {
                this.showToast('Something went wrong', 'error');
            } finally {
                parent.addItem = false;
            }
        },
        deleteItem(parent, item) {
            this.$swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const { data: response } = await this.$store.dispatch("apisection/RemoveGroupItem", item.id);
                        if(response.error){
                            return this.showToast(response.errorMessage, 'error');
                        }
                        const itemIndex = parent.apiSectionGroupItems.findIndex(i => i.id === item.id);
                        if (itemIndex !== -1) {
                            parent.apiSectionGroupItems.splice(itemIndex, 1);
                        }
                        this.showToast('Group Item deleted successfully', 'success');
                    } catch (error) {
                        this.showToast('Something went wrong', 'error');
                    }
                }
            });
        },
    },
};
</script>
<template>
    <div class="card border shadow-none mb-2">
        <div class="card-header position-relative">
            <div v-if="data.edit">
                <ApiSectionForm 
                    :sectionData="data"
                    @submit="$emit('update', $event)"
                    @cancel="data.edit = false"
                />
            </div>
            <div v-else>
                <RawData :data="data" v-if="$store.state.decrypt.isAdmin()" :keyId="`section-${data.id}`"/>
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h5 class="card-title mb-0">{{ data.name }}<template v-if="data.description">: {{ data.description  }}</template></h5>
                        <a href="javascript:void(0);" @click="viewGroups">{{ data.viewGroups ? 'Hide' : 'View' }} Groups</a>
                    </div>
                    <div class="d-flex gap-1">
                        <button class="btn btn-outline-success d-flex align-items-center gap-1" @click="data.edit = true">
                            <i class="bx bx-edit"></i> Edit
                        </button>
                        <button class="btn btn-outline-danger d-flex align-items-center gap-1" @click="$emit('delete', data.id)">
                            <i class="bx bx-trash"></i> Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body" :class="{'border-top': data.viewGroups}" v-if="data.viewGroups">
            <h5 class="mb-3">Input Group and Options</h5>
            <template v-if="data.groupLoading">
                <div class="text-center py-3">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="border-t" v-if="data.groups.length">
                    <div v-for="group in data.groups" :key="group.id" class="p-2 border rounded position-relative mb-2">
                        <template v-if="group.edit">
                            <ApiSectionGroupForm 
                                :sectionData="group"
                                @submit="saveGroup(data, $event)"
                                @cancel="group.edit = false"
                            />
                        </template>
                        <template v-else>
                            <RawData :data="group" v-if="$store.state.decrypt.isAdmin()" :keyId="`group-${group.id}`"/>
                            <div class="position-absolute" :style="{top: '5px', right: '5px'}">
                                <div class="d-flex gap-1">
                                    <i class="bx bx-edit text-success font-size-18 cursor-pointer" @click="group.edit = true"></i>
                                    <i class="bx bx-trash text-danger font-size-18 cursor-pointer" @click="deleteGroup(data, group)"></i>
                                </div>
                            </div>
                            <h6 class="mb-1">Name: <span class="text-warning">{{ group.name }}</span></h6>
                            <h6 class="mb-1">Type: <span class="text-warning">{{ group.inputType }}</span></h6>
                            <p class="mb-1" v-if="group.description">{{ group.description }}</p>
                            <p class="mb-1">Allow Multiple: <span class="text-warning">{{ group.allowMultiple ? 'Yes' : 'No' }}</span> | Required: <span class="text-warning">{{ group.isRequired ? 'Yes' : 'No' }}</span></p>
                            <template v-if="hasOptions(group)">
                                <p class="mb-1">Options:</p>
                                <ul>
                                    <li v-for="item in group.apiSectionGroupItems" :key="item.id" class="hover-toggle position-relative">
                                        <template v-if="item.edit">
                                            <GroupItemForm 
                                                :sectionData="item"
                                                @submit="saveItem(group, $event)"
                                                @cancel="item.edit = false"
                                            />
                                        </template>
                                        <template v-else>
                                            <RawData :data="item" v-if="$store.state.decrypt.isAdmin()" :keyId="`item-${item.id}`" placement="right"/>
                                            <span>{{ item.name }}<template v-if="item.description">: {{ item.description }}</template></span>
                                            <span class="v-align-middle hover-content-inline">
                                                <i class="bx bx-edit text-success cursor-pointer" @click="item.edit = true"></i>
                                                <i class="bx bx-trash text-danger cursor-pointer" @click="deleteItem(group, item)"></i>
                                            </span>
                                        </template>
                                    </li>
                                    <li>
                                        <template v-if="group.addItem">
                                            <GroupItemForm 
                                                @submit="saveItem(group, $event)"
                                                @cancel="group.addItem = false"
                                            />
                                        </template>
                                        <template v-else>
                                            <a href="javascript:void(0);" class="hover-underlined font-size-12" @click="group.addItem = true"><i class="bx bx-plus"></i> Add New Option</a>
                                        </template>
                                    </li>
                                </ul>
                            </template>
                        </template>
                    </div>
                </div>
                <div v-else class="text-center py-3">
                    <p class="mb-0">No groups found.</p>
                </div>
                <div class="px-2 border py-2 rounded mb-3" :class="{'text-center': !data.addGroup}">
                    <template v-if="data.addGroup">
                        <ApiSectionGroupForm 
                            @submit="saveGroup(data, $event)"
                            @cancel="data.addGroup = false"
                        />
                    </template>
                    <template v-else>
                        <a href="javascript:void(0);" class="text-info hover-underline" @click="data.addGroup = true"><i class="bx bx-plus"></i> Add New Group</a>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>